import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=702a6837&scoped=true&"
import script from "./orderlist.vue?vue&type=script&lang=js&"
export * from "./orderlist.vue?vue&type=script&lang=js&"
import style0 from "./orderlist.vue?vue&type=style&index=0&id=702a6837&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702a6837",
  null
  
)

export default component.exports